import { colors } from '../../constants/colors/Colors';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    amountAndNameContainersRow: {
        display: 'inline-flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        "@media (max-width: 700px)": {
            display: 'inline-block',
        },
    },
    nameContainer: {
        width: 280,
        "@media (max-width: 700px)": {
            margin: 'auto',
            marginBottom: 20,
        },
    },
    projectBillingText: {
        fontSize: 22,
        fontWeight: '400',
        letterSpacing: '-0.001em',
        lineHeight: 0
    },
    nameAndIconRow: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    iconContainer: {
        width: 30,
        height: 30,
        borderRadius: 31,
        backgroundColor: colors.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    billerName: {
        fontSize: 30,
        fontWeight: '500',
        letterSpacing: '-0.001em',
        color: colors.titleColor,
        marginLeft: 10,
        lineHeight: 0
    },
    priceContainer: {
        width: 368,
        borderRadius: 12,
        border: `1px solid ${colors.primary}`,
        height: 120,
        "@media (max-width: 700px)": {
            margin: 'auto',
        },
        "@media (max-width: 428px)": {
            width: '100%',
            height: 'auto'
        },
    },
    iconAndAmountRow: {
        display: 'inline-flex',
        "@media (max-width: 428px)": {
            width: '100%',
        },
    },
    amountBillContainer: {
        width: 256,
        paddingRight: 20,
        paddingTop: 5,
        "@media (max-width: 428px)": {
            width: '70%',
            paddingRight: 10,
            paddingLeft: 10,
            paddingTop: 0,
        },
    },
    detailsText: {
        fontSize: 14,
        fontWeight: '600',
        color: '#5B6773',
        textAlign: 'right',
        letterSpacing: "-0.1px",
        lineHeight: 0.55,
        "@media (max-width: 428px)": {
            lineHeight: 1.2
        },
    },
    amount: {
        color: colors.titleColor,
        fontSize: 26,
        fontWeight: '500',
        letterSpacing: '-0.001em',
        lineHeight: 0.5,
        textAlign: 'right',
        "@media (max-width: 428px)": {
            lineHeight: 0,
        },
    },
    fileIconContainer: {
        borderLeft: `1px solid ${colors.primary}`,
        width: 112,
        height: 120,
        backgroundColor: 'rgba(130, 78, 210, 0.16)',
        borderTopRightRadius: 12,
        borderBottomRightRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        "@media (max-width: 428px)": {
            width: '30%',
            height: 'auto'
        },
    },
    noteContainer: {
        width: '100%',
        border: `1px solid ${colors.primary}`,
        height: 'auto',
        borderRadius: 6,
        marginTop: 50,
        display: 'inline-flex'
    },
  
    infoIconContainer: {
        width: 92,
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(130, 78, 210, 0.16)',
        borderRight: `1px solid ${colors.primary}`,
        borderTopLeftRadius: 6,
        borderBottomLeftRadius: 6,
    },
   

    noteTextContainer: {
        marginLeft: 30,
    },
    noteText: {
        fontWeight: '600',
        fontSize: 16,
        color: colors.titleColor,
        lineHeight: 1.2,
    },
  
    //warning
    warningContainer: {
        width: '100%',
        background: "rgba(255, 179, 0, 0.07)",
        border: `1px solid ${colors.orangeColor}`,
        height: 'auto',
        borderRadius: 6,
        marginTop: 50,
        display: 'inline-flex'
    },
    warningIconContainer: {
        width: 92,
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ' rgba(255, 179, 0, 0.16)',
        borderRight: `1px solid ${colors.orangeColor}`,
        borderTopLeftRadius: 6,
        borderBottomLeftRadius: 6,
    },
    warningText: {
        fontWeight: '600',
        fontSize: 16,
        color: colors.orangeColor,
        lineHeight: 1.2,
    },
    importantNote: {
        color: '#5B6773',
        fontSize: 16,
        fontWeight: '400',
    },
    importantWarning: {
        color: colors.orangeColor,
        fontSize: 16,
        fontWeight: '400',
    },
    root: {
        marginTop: 50,
        flexGrow: 1,
        borderRadius: 12,
        border: '1px solid #D4DDE4',
        width: '100%',
        paddingBottom: 36
    },
    appBar: {
        borderRadius: '12px 12px 0 0',
        backgroundColor: '#E6EDF3',
        padding: 20,
    },
    selected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        background: 'linear-gradient(#824ED2, #B07DFF)',
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor:'pointer',
    },
    notSelected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor:'pointer',
    },
    tabHead: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto-SemiBold',
    },
    activeTab: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#FFFFFF',
        fontFamily: 'Roboto-SemiBold',
    },
    tabsBodyContainer: {
        paddingLeft: 30,
        paddingRight: 30,
        width: '100%'
    },
    tableTitleRow: {
        display: 'inline-flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        marginTop:10,
    },

    tableTitle: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
    },
    titleForAll: {
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
        color: colors.primary,
    },
   
  
   
}));